import type { TOC } from '@ember/component/template-only';

interface Signature {
  Args: {};
}

const ItemsIndexLoading: TOC<Signature> = <template>
  <h1 class="mb-6 text-3xl font-bold">Items</h1>

  <div class="tabs tabs-box mb-4 flex-wrap">
    <span class="tab">All</span>
    <span class="tab">Movies<div
        class="skeleton ml-1 inline-block h-3 w-5"
      ></div></span>
    <span class="tab">TV Shows<div
        class="skeleton ml-1 inline-block h-3 w-5"
      ></div></span>
    <span class="tab">People<div
        class="skeleton ml-1 inline-block h-3 w-5"
      ></div></span>
    <span class="tab">Books<div
        class="skeleton ml-1 inline-block h-3 w-5"
      ></div></span>
    <span class="tab">Music<div
        class="skeleton ml-1 inline-block h-3 w-5"
      ></div></span>
    <span class="tab">Podcasts<div
        class="skeleton ml-1 inline-block h-3 w-5"
      ></div></span>
    <span class="tab">Recipes<div
        class="skeleton ml-1 inline-block h-3 w-5"
      ></div></span>
    <span class="tab">Games<div
        class="skeleton ml-1 inline-block h-3 w-5"
      ></div></span>
    <span class="tab">Places<div
        class="skeleton ml-1 inline-block h-3 w-5"
      ></div></span>
    <span class="tab">Products<div
        class="skeleton ml-1 inline-block h-3 w-5"
      ></div></span>
  </div>

  <div class="mb-6 flex flex-wrap items-center gap-2">
    <span class="text-base-content/60 text-sm font-medium">Sort by:</span>
    <span class="btn btn-sm btn-outline">Recently added</span>
    <span class="btn btn-sm btn-outline">Most mentioned</span>
    <span class="btn btn-sm btn-outline">A → Z</span>
    <span class="btn btn-sm btn-outline">Highest consensus</span>
  </div>

  <div class="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
    <div class="bg-base-100 rounded-box p-4 shadow">
      <div class="skeleton mb-3 h-36 w-full"></div>
      <div class="skeleton mb-2 h-5 w-3/4"></div>
      <div class="skeleton mb-2 h-4 w-1/2"></div>
      <div class="skeleton h-4 w-2/3"></div>
    </div>
    <div class="bg-base-100 rounded-box p-4 shadow">
      <div class="skeleton mb-3 h-36 w-full"></div>
      <div class="skeleton mb-2 h-5 w-2/3"></div>
      <div class="skeleton mb-2 h-4 w-1/3"></div>
      <div class="skeleton h-4 w-3/4"></div>
    </div>
    <div class="bg-base-100 rounded-box p-4 shadow">
      <div class="skeleton mb-3 h-36 w-full"></div>
      <div class="skeleton mb-2 h-5 w-4/5"></div>
      <div class="skeleton mb-2 h-4 w-2/5"></div>
      <div class="skeleton h-4 w-1/2"></div>
    </div>
  </div>

  <div class="mt-8 flex justify-center">
    <div class="bg-base-100 rounded-box h-10 w-56 shadow">
      <div class="skeleton h-full w-full"></div>
    </div>
  </div>
</template>;

export default ItemsIndexLoading;
